import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditEventModal = ({ isOpen, onClose, onSuccess, eventData, isLoggedIn }) => {
    const [date, setDate] = useState('');
    const [title, setTitle] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [newImages, setNewImages] = useState([]);
    const [loading, setLoading] = useState(false);

    const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || process.env.REACT_APP_LINK || '';

    useEffect(() => {
        if (eventData) {
            setDate(eventData.date || '');
            setTitle(eventData.title || '');
            setShortDescription(eventData.shortDescription || '');
        }
    }, [eventData]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        setNewImages(files);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!eventData || !date || !title.trim()) {
            toast.warning('Date and Title are required');
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('date', date);
            formData.append('title', title.trim());
            formData.append('shortDescription', shortDescription.trim());
            formData.append('adminId', isLoggedIn.user_id);

            newImages.forEach((file) => {
                formData.append('images', file);
            });

            const response = await axios.put(
                `${BASE_URL}/events/${eventData.id}`,
                formData
            );

            if (response.status === 200) {
                toast.success('Event updated successfully');
                setNewImages([]);
                onSuccess();
                onClose();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error updating event');
        } finally {
            setLoading(false);
        }
    };

    const getImageUrl = (img) => {
        if (!img) return null;
        if (String(img).startsWith('http')) return img;
        const str = String(img).replace(/\\/g, '/');
        const base = (BASE_URL || '').replace(/\/+$/, '');
        return base ? `${base}/${str}` : null;
    };

    if (!isOpen || !eventData) return null;

    return (
        <div className="custom-modal-overlay" onClick={onClose}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Edit Event</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="edit-date" className="oms-form-label">Date</label>
                        <input
                            type="date"
                            id="edit-date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="edit-title" className="oms-form-label">Title</label>
                        <input
                            type="text"
                            id="edit-title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter event title"
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="edit-shortDescription" className="oms-form-label">Short Description</label>
                        <textarea
                            id="edit-shortDescription"
                            value={shortDescription}
                            onChange={(e) => setShortDescription(e.target.value)}
                            placeholder="Enter short description"
                            rows={4}
                        />
                    </div>
                    {eventData.images && Array.isArray(eventData.images) && eventData.images.length > 0 && (
                        <div className="oms-form-group">
                            <label className="oms-form-label">Current Images</label>
                            <div className="event-edit-thumbs">
                                {eventData.images.map((img, i) => (
                                    <img key={i} src={getImageUrl(img)} alt="" className="event-edit-thumb" />
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="oms-form-group">
                        <label htmlFor="edit-images" className="oms-form-label">Add More Images</label>
                        <input
                            type="file"
                            id="edit-images"
                            accept="image/jpeg,image/jpg,image/png,image/webp,image/avif"
                            multiple
                            onChange={handleFileChange}
                        />
                        {newImages.length > 0 && (
                            <small>{newImages.length} new file(s) selected</small>
                        )}
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={onClose}>Cancel</button>
                        <button type="submit" disabled={loading}>
                            {loading ? 'Saving...' : 'Update Event'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditEventModal;
